import { ReactNode } from "react";
import { darkModeAtom } from "../../atoms/user/darkModeAtom";
import { useAtomValue } from "jotai";
import { ThemeDiv } from "../../stories/screens/ThemeDiv/ThemeDiv";

export const ScrollManagement = ({ children }: { children: ReactNode }) => {
  const darkMode = useAtomValue(darkModeAtom);
  return <ThemeDiv darkMode={darkMode ? "dark" : ""}>{children}</ThemeDiv>;
};
